import { Button, Col, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { defineValueInInput, getElementFromId, getValueFromInput } from "../../../components/funcForInput";
import removeAllErrorMsg from "../../../components/funcRemoveAllErros";
import { signatarioDadosDto } from "./signatarios.dto";
import styles from "./styles.module.css";
import $ from "jquery";
import "jquery-mask-plugin";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import funcSleep from "../../../components/funcSleep";
import ModalPesquisarColaboradores from "./ModalPesquisarColaboradores";

export default function RenderSignatarios({ handleUpdate, handleFinalizar }: iProps) {
    const documentoDados = useSelector((state: any) => state.uiDocumentos.documentoDados)
    const [signatariosDados, setSignatariosDados] = useState<signatarioDadosDto[]>(parseSignatarios(documentoDados.signatarios))
    const [permitirEdicao, setPermitirEdicao] = useState<boolean>(true)
    const [permitirConfig, setPermitirConfig] = useState<boolean>(true)
    const [showModalColaboradores, setShowModalColaboradores] = useState<boolean>(false)
    
    useEffect(() => {
        defineMaskInputs()
        if (documentoDados.id_status.id_status > 1) { 
            setPermitirEdicao(false)
            setPermitirConfig(false)
        }
        for (let sig of documentoDados.signatarios) { 
            if (sig.qtd_visualizacao > 0) { 
                setPermitirEdicao(false)
                break;
            }
        }
        // eslint-disable-next-line
    }, [])
    
    function parseSignatarios(signatarios: any[]) {
        let sigs: signatarioDadosDto[] = [];
        for (let sig of signatarios) {
            const novo_signatario: signatarioDadosDto = {
                id_signatario: sig.id_signatario,
                id_documento: sig.id_documento,
                id_funcao: sig.id_funcao,
                id_colaborador: sig.id_colaborador,
                nome_completo: sig.nome_completo,
                email: sig.email,
                celular: sig.celular,
                cpf: sig.cpf,
                auth_assinatura: sig.auth_assinatura,
                auth_sms: sig.auth_sms,
                auth_selfie: sig.auth_selfie,
                auth_cpf: sig.auth_cpf,
            };
            sigs.push(novo_signatario);
        }
        return sigs;
    }
    function getSignatarios(): signatarioDadosDto[] {
        const form: any = getElementFromId("formNovoDocumento");
        let sigs: signatarioDadosDto[] = [];
        for (let idx in signatariosDados) {
            let sig = signatariosDados[Number(idx)];
            const novo_signatario: signatarioDadosDto = {
                id_signatario: sig.id_signatario,
                id_documento: sig.id_documento,
                id_funcao: sig.id_funcao,
                id_colaborador: sig.id_colaborador,
                nome_completo: getValueFromInput(`${idx}_nome_completo`),
                email: getValueFromInput(`${idx}_email`),
                celular: unmaskTelefone(getValueFromInput(`${idx}_telefone`)),
                cpf: unmaskCpf(getValueFromInput(`${idx}_cpf`)),
                auth_assinatura: form[`${idx}_auth_assinatura`].checked === true ? 1 : 0,
                auth_sms: form[`${idx}_auth_sms`].checked === true ? 1 : 0,
                auth_selfie: form[`${idx}_auth_selfie`].checked === true ? 1 : 0,
                auth_cpf: form[`${idx}_auth_cpf`].checked === true ? 1 : 0,
            };
            sigs.push(novo_signatario);
        }
        return sigs;
    }
    async function addSignatarioVazio() {
        if (Object.values(documentoDados).length === 0) {
            toast.warn("Arquivo em PDF não enviado!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            return;
        }

        const novo_signatario: signatarioDadosDto = {
            id_signatario: null,
            id_documento: documentoDados.id,
            id_funcao: 1,
            id_colaborador: null,
            nome_completo: "",
            email: null,
            celular: null,
            cpf: "",
            auth_assinatura: 1,
            auth_sms: 0,
            auth_selfie: 0,
            auth_cpf: 1,
        };
        let sigs: signatarioDadosDto[] = [];
        let sigsOld = getSignatarios();
        for (let reg of sigsOld) {
            sigs.push(reg);
        }
        sigs.push(novo_signatario);
        setSignatariosDadosAux(sigs)
    }
    async function setSignatariosDadosAux(sigs: signatarioDadosDto[]) {
        setSignatariosDados(sigs)
        await funcSleep(128);
        defineMaskInputs();
    }
    async function delSignatario(idx: number) {
        if (!window.confirm("Tem certeza que deseja remover o Signatário?")) {
            return;
        }
        let sigsOld: signatarioDadosDto[] = getSignatarios();
        let sigs: signatarioDadosDto[] = [];
        for (let id in sigsOld) {
            if (Number(id) === idx) {
                continue;
            }
            sigs.push(sigsOld[id]);
        }
        // handleUpdate(sigs);
        setSignatariosDados([])
        await funcSleep(50);
        setSignatariosDadosAux(sigs)
    }
    async function saveSignatraios(openAssinaturas:boolean) {
        removeAllErrorMsg();
        const form: any = getElementFromId("formNovoDocumento");
        let dadosValidados = true;
        let signatariosOld: signatarioDadosDto[] = getSignatarios();
        let signatariosNew: signatarioDadosDto[] = [];
        let signatariosDuplicados: boolean = false;
        for (let idx in signatariosOld) {
            const novo_signatario: signatarioDadosDto = signatariosOld[idx];
            for (let idxAux in signatariosOld) {
                const sigAux: signatarioDadosDto = signatariosOld[idxAux];
                if (idxAux === idx) { 
                    continue;
                }
                if (sigAux.id_colaborador === novo_signatario.id_colaborador || sigAux.cpf === novo_signatario.cpf) { 
                    signatariosDuplicados = true;
                }
            }
            
            if (novo_signatario.nome_completo.length === 0) {
                form[`${idx}_nome_completo`].nextElementSibling.style.display = "block";
                dadosValidados = false;
            }
            if (novo_signatario.cpf.length !== 11) {
                form[`${idx}_cpf`].nextElementSibling.style.display = "block";
                dadosValidados = false;
            }
            if (novo_signatario.celular) {
                if (novo_signatario.celular.length > 0 && novo_signatario.celular.length < 11) {
                    form[`${idx}_telefone`].nextElementSibling.style.display = "block";
                    dadosValidados = false;
                }
            }
            if (novo_signatario.email?.length === 0) {
                novo_signatario.email = null;
            }
            signatariosNew.push(novo_signatario);
        }
        if (signatariosDuplicados) { 
            toast.warn("Remover signatários com o mesmo CPF!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            return;
        }
        if (!dadosValidados) {
            toast.warn("Verifique os dados de todos os signatários!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        } else {
            handleUpdate(signatariosNew, openAssinaturas);
            setSignatariosDadosAux(signatariosNew)
        }
    }
    async function handleAdicionarColaborador(colaborador: any) { 
        console.log(colaborador)
        if (Object.values(colaborador).length === 0) { 
            toast.warn("Erro ao adicionar colaborador!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            return;
        }
        setShowModalColaboradores(false)
        const novo_signatario: signatarioDadosDto = {
            id_signatario: null,
            id_documento: documentoDados.id,
            id_funcao: 1,
            id_colaborador: colaborador.id_colaborador,
            nome_completo: colaborador.nome_completo,
            email: colaborador.email,
            celular: colaborador.telefone,
            cpf: colaborador.cpf,
            auth_assinatura: 1,
            auth_cpf: 1,
            auth_sms: 0,
            auth_selfie: 0,
        };
        let sigs: signatarioDadosDto[] = [];
        let sigsOld = getSignatarios();
        const existe = sigsOld.filter(reg => reg.id_colaborador === novo_signatario.id_colaborador || reg.cpf === novo_signatario.cpf).length > 0 ? true : false
        if (existe) { 
            toast.warn("Não é possível adicionar a mesma pessoa!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            return;
        }
        for (let reg of sigsOld) {
            sigs.push(reg);
        }
        sigs.push(novo_signatario);
        setSignatariosDadosAux(sigs)
        // toast.success("Colaborador adicionado com sucesso!", {
        //     containerId: 1,
        //     position: "top-center",
        //     theme: "dark",
        // });
    }
    async function handleFinalizarAux() { 
        await saveSignatraios(false);
        handleFinalizar();
    }

    return (
        <div id="documento_signatarios">
            <ModalPesquisarColaboradores show={showModalColaboradores} handleClose={() => setShowModalColaboradores(false)} handleAdicionarColaborador={(reg:any) => handleAdicionarColaborador(reg)} />
            
            <h2>Definir Signatários ({signatariosDados.length})</h2>
            <br></br>
            <div className="div-row">
                
                <Button
                    onClick={() => {
                        saveSignatraios(false);
                    }}
                    variant="success"
                    style={{ height: "40px", marginRight: "10px", display: permitirEdicao ? "flex" : "none" }}
                    className="div-row-space-between"
                >
                    Salvar Signatários <span className="material-symbols-outlined">save</span>
                </Button>
                <Button
                    onClick={() => {
                        saveSignatraios(true);
                    }}
                    variant="warning"
                    style={{ height: "40px", marginRight: "10px", display: permitirConfig ? "flex" : "none" }}
                    className="div-row-space-between"
                >
                    Definir Posição Assinaturas ({documentoDados.assinaturas.length}) <span className="material-symbols-outlined">contract_edit</span>
                </Button>
                <Button
                    onClick={() => {
                        handleFinalizarAux()
                    }}
                    variant="success"
                    style={{ height: "40px", marginRight: "10px", display: permitirConfig ? "flex" : "none" }}
                    className="div-row-space-between"
                >
                    Finalizar Documento <span className="material-symbols-outlined">priority</span>
                </Button>
            </div>
            <br></br>
            <div className="div-row">
                <Button
                    onClick={() => {
                        addSignatarioVazio();
                    }}
                    variant="primary"
                    style={{ height: "40px", marginRight: "10px", display: permitirEdicao ? "flex" : "none" }}
                    className="div-row-space-between"
                >
                    Adicionar Signatário <span className="material-symbols-outlined">add</span>
                </Button>
                <Button
                    onClick={() => {
                        setShowModalColaboradores(true);
                    }}
                    variant="primary"
                    style={{ height: "40px", marginRight: "10px", display: permitirEdicao ? "flex" : "none" }}
                    className="div-row-space-between"
                >
                    Pesquisar Colaborador <span className="material-symbols-outlined">search</span>
                </Button>
            </div>
            {signatariosDados.map((sig, idx) => {
                return (
                    <div key={idx} className={styles.div_signatario}>
                        <div className="div-row" style={{ alignItems: "initial" }}>
                            <Col className="col-4">
                                <Form.Group>
                                    <Form.Label>Nome Completo:</Form.Label>
                                    <Form.Control name={`${idx}_nome_completo`} type="text" autoComplete="off" id={`${idx}_nome_completo`} defaultValue={sig.nome_completo} placeholder="" disabled={!permitirEdicao} />
                                    <Form.Control.Feedback type="invalid">Informe o Nome Completo!</Form.Control.Feedback>
                                </Form.Group>
                                <br></br>
                                <Form.Group>
                                    <Form.Label>CPF:</Form.Label>
                                    <Form.Control name={`${idx}_cpf`} type="text" autoComplete="off" id={`${idx}_cpf`} className="cpf" defaultValue={formatCpf(sig.cpf)} disabled={!permitirEdicao} />
                                    <Form.Control.Feedback type="invalid">Informe o CPF corretamente!</Form.Control.Feedback>
                                </Form.Group>
                                <br></br>
                                <Form.Group>
                                    <Form.Label>Telefone:</Form.Label>
                                    <Form.Control name={`${idx}_telefone`} type="text" autoComplete="off" id={`${idx}_telefone`} defaultValue={formatTelefone(sig.celular! === null ? "" : sig.celular)} className="telefone" disabled={!permitirEdicao} />
                                    <Form.Control.Feedback type="invalid">Informe o Telefone corretamente!</Form.Control.Feedback>
                                </Form.Group>
                                <br></br>
                                <Form.Group>
                                    <Form.Label>Email:</Form.Label>
                                    <Form.Control name={`${idx}_email`} type="email" autoComplete="off" id={`${idx}_email`} defaultValue={sig.email!} placeholder="" disabled={!permitirEdicao} />
                                    <Form.Control.Feedback type="invalid">Informe o E-mail corretamente!</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col
                                className="col-4"
                                style={{
                                    marginLeft: "20px",
                                    minHeight: "100%",
                                    position: "relative",
                                }}
                            >
                                <Form.Label>Selecione os métodos de autenticação:</Form.Label>
                                <Form.Check type="switch" id={`${idx}_auth_cpf`} label="CPF" className={styles.inputCheck} defaultChecked={sig.auth_cpf === 1 ? true : false} disabled={!permitirEdicao} />
                                <Form.Check type="switch" id={`${idx}_auth_assinatura`} label="Assinatura na Tela" className={styles.inputCheck} defaultChecked={sig.auth_assinatura === 1 ? true : false} disabled={!permitirEdicao} />
                                <Form.Check type="switch" id={`${idx}_auth_sms`} label="Código via SMS" className={styles.inputCheck} defaultChecked={sig.auth_sms === 1 ? true : false} disabled={!permitirEdicao} />
                                <Form.Check type="switch" id={`${idx}_auth_selfie`} label="Selfie" className={styles.inputCheck} defaultChecked={sig.auth_selfie === 1 ? true : false} disabled={!permitirEdicao} />
                                <Button
                                    onClick={() => {
                                        delSignatario(idx);
                                    }}
                                    variant="danger"
                                    style={{
                                        height: "40px",
                                        position: "absolute",
                                        bottom: "0",
                                        display: permitirEdicao ? "flex" : "none",
                                    }}
                                    className="div-row-space-between"
                                >
                                    Remover Signatário <span className="material-symbols-outlined">delete</span>
                                </Button>
                            </Col>
                        </div>
                    </div>
                );
            })}
            <br></br>
        </div>
    );
}
interface iProps {
    handleUpdate: any;
    handleFinalizar: any;
}
function defineMaskInputs() {
    $(".cpf").mask("000.000.000-00", {
        reverse: false,
        placeholder: "###.###.###-##",
    });
    $(".telefone").mask("(00) 00000-0000", {
        reverse: false,
        placeholder: "(##) #####-####",
    });
}
function unmaskCpf(valor: string) {
    return valor.replaceAll(".", "").replaceAll("-", "");
}
function unmaskTelefone(valor: string) {
    if (valor === "") {
        return null;
    }
    return valor.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replaceAll("-", "");
}
function formatCpf(valor: string): string {
    defineValueInInput("cpf_aux", valor);
    return $("#cpf_aux").masked(valor);
}
function formatTelefone(valor: string): string {
    defineValueInInput("telefone_aux", valor);
    return $("#telefone_aux").masked(valor);
}
